<template>
  <div class="email-form">
    <form ref="emailBox" @submit.prevent="onSubscribe()" _u_id_name_="email">
      <div class="email-box">
        <input type="email" placeholder="Your email" v-model="email" class="email-input input" :class="[error && 'error']" @focus="onFocus" />
        <button type="submit" class="email-input-submit" aria-label="Submit email for subscription">
          <template v-if="sending">
            <span class="loader tiny"></span>
          </template>
          <template v-else-if="!inputFocused && done">
            <checkmark />
          </template>
          <template v-else> Subscribe </template>
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import { isValidEmail } from '../utils/Utils.js';
import checkmark from '../assets/icons/checkmark.svg';

export default {
  name: 'EmailBoxForm',
  components: {
    checkmark,
  },
  props: {
    center: { 
      type: Boolean,
      default: false,
    },
    sending: {
      type: Boolean,
      default: false,
    },
    done: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      inputFocused: false,
      email: '',
    };
  },
  methods: {
    onFocus() {
      this.inputFocused = true;
    },
    onSubscribe() {
      const email = this.email.trim();

      if (!this.email) {
        this.$emit('validationError', 'Please enter your email');
        return;
      }

      if (!isValidEmail(email)) {
        this.$emit('validationError', 'Please enter a valid email address');
        return;
      }

      this.$emit('submitEmail', email);
      this.inputFocused = false;
    },
  },
  watch: {
    done: {
      handler(done) {
        if (done && !this.error) {
          this.email = '';
        }
      },
    },
  },
};
</script>

<style lang="postcss" scoped>
@import '@/pixel/style/variables';

.email-form {
  width: auto;
  svg {
    path {
      fill: white !important;
    }
  }

  .email-input-submit {
    width: 100%;
    margin-top: var(--space-4);
  }
  .email-box {
    width: auto;
  }

  @media (min-width: $tablet-breakpoint) {
    .email-box {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: row;
    }
    .email-input {
      width: 272px;
      min-width: 272px;
    }
    .email-input-submit {
      margin-left: 16px;
      margin-top: 0;
    }
  }
}
</style>
